<template>
  <div :class="$options.name" class="twt-flex tw:flex-col tw:gap-2 tw:w-full">
    <div class="tw:flex tw:flex-col tw:gap-2">
      <EdroneSelect
        :options="options"
        :placeholder="trans._menu.item.language"
        :selected-options="options.find((option) => option.value === selected)"
        @select="handleSelectChangeAccount($event.value)"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import EdroneSelect from "edrone-components/EdroneSelect.vue";
import { ref } from "vue";

const handleSelectChangeAccount = (value: string) => {
  window.location.href = "/login?lang=" + value;
};

const options = [
  { value: "en", name: "English" },
  { value: "pl", name: "Polski" },
  { value: "pt", name: "Portuguese" },
  { value: "es", name: "Español" },
];

const selected = ref(
  Number(window.EDRONE_CONTEXT.trackerId) === 5161
    ? "pl"
    : Number(window.EDRONE_CONTEXT.trackerId) === 5162
    ? "pt"
    : "en"
);
</script>
